<div class="app-page-not-found">
  <div class="app-404-page">
    <div class="app-404-header">{{ 'page-not-found.title' | translate }}</div>
    <div class="app-404-go-home">{{ 'page-not-found.go' | translate }} <a routerLink='/'>{{ 'page-not-found.home' | translate }}</a></div>
    <div class="app-404-footer">404</div>
  </div>
</div>